import sanitizeHtml from "sanitize-html";

// Email HTML is table-based, so the layout, headings, and cell-level styling that carry a message's
// design must survive sanitization or the body collapses to unstyled text. `style` and `class` are
// allowed on every element (inline `style` is how email CTAs are styled); `<style>` blocks are NOT
// allowed (sanitize-html strips them, and a raw global stylesheet is a broader surface than this
// shared, inbound-email-facing boundary should carry).
const STYLE_AND_CLASS = ["style", "class"];

export const sanitizeEmailHTMLContent = (html: string) =>
  sanitizeHtml(html, {
    allowedTags: [
      "a",
      "strong",
      "b",
      "em",
      "i",
      "u",
      "br",
      "p",
      "img",
      "div",
      "span",
      "blockquote",
      "code",
      // Headings
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      // Tables (email layout)
      "table",
      "thead",
      "tbody",
      "tfoot",
      "tr",
      "td",
      "th",
      "caption",
      "colgroup",
      "col",
    ],
    allowedAttributes: {
      "*": STYLE_AND_CLASS,
      a: ["href", "target", "rel", ...STYLE_AND_CLASS],
      img: ["src", "alt", "width", "height", ...STYLE_AND_CLASS],
      td: ["colspan", "rowspan", ...STYLE_AND_CLASS],
      th: ["colspan", "rowspan", "scope", ...STYLE_AND_CLASS],
      col: ["span", ...STYLE_AND_CLASS],
      colgroup: ["span", ...STYLE_AND_CLASS],
    },
    // Automatically add security attributes to external links
    transformTags: {
      a: (tagName, attribs) => {
        const href = attribs.href || "";
        // Add target="_blank" and security attributes for external links
        if (href.startsWith("http://") || href.startsWith("https://")) {
          return {
            tagName,
            attribs: {
              ...attribs,
              target: "_blank",
              rel: "noopener noreferrer",
            },
          };
        }
        return { tagName, attribs };
      },
    },
    // Allow only safe protocols for images and links
    allowedSchemesByTag: {
      img: ["http", "https", "data"],
      a: ["http", "https", "mailto", "tel"],
    },
  });
